import React from 'react'

import { Modal } from 'react-bootstrap'

export default class konfirmasi extends React.Component {

    render() {
        const { ShowKonfirm, saveHandler, mode } = this.props

        return (
            <div class="mb-10">

                <Modal show={ShowKonfirm}>
                    <Modal.Body>

                        <div>
                            <h5 class="text-center">Data Telah di{mode}</h5>
                        </div>

                        <div class="text-center">
                            <button type="button" class="btn btn-primary" onClick={saveHandler}>OKE</button>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}